import * as IconSax from "iconsax-react";
import { ComponentProps, useContext, useMemo } from "react";
import { twMerge } from "tailwind-merge";
import { IconName, IconVariant } from "types";
import { IconButtonContext } from "./IconButton";

type Props = {
  name: IconName;
  variant?: IconVariant;
  size?: number | string;
  className?: string;
};

function Icon({
  name,
  variant,
  className = "",
  ...props
}: Props & Omit<ComponentProps<"svg">, "ref">) {
  const iconButtonContext = useContext(IconButtonContext);
  const Component = useMemo(() => IconSax[name], [name]);
  return (
    <Component
      variant={variant}
      className={twMerge(
        "inline-block align-middle",
        iconButtonContext?.iconClassName,
        className
      )}
      {...props}
    />
  );
}

export default Icon;
